import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';


const columnData = [
  {
    id: 'number', numeric: true, disablePadding: false, label: 'Numéro',
  },
  {
    id: 'state', numeric: false, disablePadding: false, label: 'État',
  },
  {
    id: 'bike', numeric: false, disablePadding: false, label: 'Vélo',
  }
];

export const StandTableHead = () =>
      <TableHead>
        <TableRow>
          {columnData.map(column => (
            <TableCell
              key={column.id}
              padding={column.disablePadding ? 'none' : 'normal'}
            >
              <TableSortLabel>
                {column.label}
              </TableSortLabel>
            </TableCell>
          ), this)}
          <TableCell padding="checkbox">
          </TableCell>
        </TableRow>
      </TableHead>;


export default StandTableHead;



// WEBPACK FOOTER //
// ./src/components/Stand/StandTableHead.jsx